<div class="main-layout">
    <app-sidebar />

    <main class="content-area">
        <header class="d-flex justify-content-between align-items-center p-3 pt-2"
            style="--bs-bg-opacity: .8; backdrop-filter: blur(4px);">
            <div class="d-flex align-items-center">
                <button class="btn btn-dark d-md-none me-3" type="button" data-bs-toggle="offcanvas"
                    data-bs-target="#mainSidebarOffcanvas" aria-controls="mainSidebarOffcanvas" title="Toggle">
                    <i class="bi bi-list fs-3"></i>
                </button>
                <h4 class="fw-bold mb-0">{{ pageTitle() }}</h4>
            </div>
            <div class="d-flex align-items-center header-actions" [style.padding-right]="isElectron() ? '9rem': '0'">
                @if (isAdmin()) {
                <button class="btn btn-dark me-2" type="button" data-bs-toggle="modal" data-bs-target="#adminModal"
                    title="Admin Control Panel">
                    <i class="bi bi-shield-lock-fill"></i>
                </button>
                <button class="btn btn-dark me-2" type="button" data-bs-toggle="modal"
                    data-bs-target="#createLobbyModal" title="Create New Lobby">
                    <i class="bi bi-plus-lg"></i>
                </button>
                }
                @if (isElectron()) {
                <button class="btn btn-dark me-2" type="button" data-bs-toggle="modal"
                    data-bs-target="#refreshConfirmModal" title="Refresh Application">
                    <i class="bi bi-arrow-clockwise"></i>
                </button>
                }
                <button class="btn btn-dark me-2 position-relative" [class.has-unread-attention]="hasUnreadMessages()" type="button" data-bs-toggle="offcanvas"
                    data-bs-target="#pagerOffcanvas" title="Pager">
                    <i class="bi bi-chat-square-text-fill"></i>
                    @if (hasUnreadMessages()) {
                    <span class="notification-dot-header"></span>
                    }
                </button>
                <div class="dropdown">
                    <button class="btn btn-dark me-2 position-relative" [class.has-unread-attention]="hasPendingRequests()" type="button" id="notificationsDropdown"
                        data-bs-toggle="dropdown" aria-expanded="false" title="Notifications">
                        <i class="bi bi-bell-fill"></i>
                        @if (hasPendingRequests()) {
                        <span class="notification-dot-header"></span>
                        }
                    </button>
                    <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end notifications-dropdown border-0 shadow"
                        role="list" aria-labelledby="notificationsDropdown"
                        style="width: 320px;z-index: 100000 !important;">
                        <li class="px-3 py-2 fw-bold text-uppercase small border-bottom border-dark">Notifications
                            ({{ pendingRequests().length }})
                        </li>
                        @if (hasPendingRequests()) {
                        @for (request of pendingRequests(); track $index) {
                        <li class="px-3 py-2 d-flex align-items-center">
                            <!--<img [src]="request.from.avatar" class="rounded-circle me-2" width="40" height="40"
                                alt="avatar">-->
                            <div class="flex-grow-1 text-truncate">
                                <span class="fw-bold d-block">{{ request.fromUserName }}</span>
                                @if (request.isInvite) {
                                <small class="text-muted">Invite</small>
                                } @else {
                                <small class="text-muted">Friend Request</small>
                                }
                            </div>
                            <div class="ms-2 d-flex gap-1">
                                <button class="btn btn-sm btn-success" (click)="acceptRequest(request)" title="Accept">
                                    <i class="bi bi-check-lg"></i>
                                </button>
                                <button class="btn btn-sm btn-danger" (click)="declineRequest(request)" title="Decline">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                            </div>
                        </li>
                        }
                        } @else {
                        <li class="px-3 py-4 text-center text-muted">No pending notifications</li>
                        }
                    </ul>
                </div>
                <button class="btn btn-dark" type="button" data-bs-toggle="collapse" data-bs-target="#friendsCollapse"
                    aria-expanded="true" aria-controls="friendsCollapse" title="Friends List">
                    <i class="bi bi-people-fill"></i>
                </button>

                <!--user-profile-button-->
                <div class="dropdown ms-2">
                    <button class="btn btn-dark d-flex align-items-center gap-2 p-1 pe-2 border-0 user-header-profile-btn"
                        type="button" id="userHeaderProfileDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                        title="User Profile Menu">
                        <div class="position-relative d-flex align-items-center justify-content-center">
                            <img [src]="currentUser().avatar" class="rounded-circle border border-secondary"
                                style="width: 32px; height: 32px; object-fit: cover;" alt="Avatar" />
                            <span class="position-absolute bottom-0 end-0 rounded-circle border border-dark"
                                [class]="getStatusBgColor(userStatus())" style="width: 10px; height: 10px;"></span>
                        </div>
                        <div class="d-none d-sm-flex flex-column align-items-start text-start lh-1 me-1 ms-1">
                            <span class="fw-bold small text-truncate" [style.color]="userNameColor() || '#ffffff'" style="max-width: 110px;">
                                {{ currentUser().name }}
                            </span>
                            <span class="text-muted extra-small mt-1" style="font-size: 0.7rem;">
                                {{ getStatusText(userStatus()) }}
                            </span>
                        </div>
                        <i class="bi bi-chevron-down extra-small text-muted"></i>
                    </button>

                    <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end shadow border-0 p-2"
                        aria-labelledby="userHeaderProfileDropdown" style="min-width: 220px; z-index: 100000 !important;">
                        
                        <li class="px-2 py-2 mb-2 border-bottom border-secondary border-opacity-25 d-flex align-items-center gap-2">
                            <img [src]="currentUser().avatar" class="rounded-circle" style="width: 36px; height: 36px; object-fit: cover;" alt="Avatar">
                            <div class="overflow-hidden">
                                <div class="fw-bold text-truncate" [style.color]="userNameColor() || '#ffffff'">{{ currentUser().name }}</div>
                                <div class="extra-small text-muted d-flex align-items-center gap-1">
                                    <span class="d-inline-block rounded-circle" [class]="getStatusBgColor(userStatus())" style="width: 8px; height: 8px;"></span>
                                    {{ getStatusText(userStatus()) }}
                                </div>
                            </div>
                        </li>

                        <li>
                            <button class="dropdown-item d-flex align-items-center gap-2 py-2 rounded-2" type="button"
                                data-bs-toggle="modal" data-bs-target="#avatarChangeModal">
                                <i class="bi bi-person-bounding-box text-primary"></i>
                                <span>Change Portrait</span>
                            </button>
                        </li>
                        <li>
                            <button class="dropdown-item d-flex align-items-center gap-2 py-2 rounded-2" type="button"
                                data-bs-toggle="modal" data-bs-target="#nameplateChangeModal">
                                <i class="bi bi-card-image text-warning"></i>
                                <span>Change Name Plate</span>
                            </button>
                        </li>
                        <li>
                            <button class="dropdown-item d-flex align-items-center gap-2 py-2 rounded-2" type="button"
                                data-bs-toggle="modal" data-bs-target="#nameColorModal">
                                <i class="bi bi-palette-fill text-info"></i>
                                <span>Change Name Color</span>
                            </button>
                        </li>
                    </ul>
                </div>
                <!--./user-profile-button-->
            </div>
        </header>
        <div class="d-flex flex-row flex-grow-1 overflow-hidden">
            <div class="flex-grow-1 overflow-x-hidden" [class.overflow-auto]="!noPadding()">
                <router-outlet></router-outlet>
            </div>
            <app-friendbar></app-friendbar>
        </div>
    </main>

    <app-settings></app-settings>
    <app-pager></app-pager>
    <app-password-modal></app-password-modal>
    <app-nameplate-modal></app-nameplate-modal>
    <app-avatar-modal></app-avatar-modal>
    <app-name-color-modal></app-name-color-modal>
    <app-create-lobby-modal></app-create-lobby-modal>
    @if (isAdmin()) {
    <app-admin-modal></app-admin-modal>
    }

    <!-- Refresh Confirmation Modal -->
    @if (isElectron()) {
    <app-refresh-modal></app-refresh-modal>
    }

    <!-- Global System Award Loot Chest Modal -->
    @if (messenger.unlockedReward(); as rewardObj) {
    <app-loot-opening-modal
        [reward]="rewardObj"
        (close)="messenger.unlockedReward.set(null)">
    </app-loot-opening-modal>
    }
</div>